<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Empresas'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <form v-on:submit.prevent="getList()">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>ID da empresa
                          <span class="hint-help" title="Aceita um ou vários IDs separados por vírgula (ex: id1,id2,id3).">?</span>
                        </label>
                        <input v-model="dataSearch.id" type="text" class="form-control" id="id" name="id"
                               placeholder="ID único ou vários separados por vírgula">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Nome da empresa</label>
                        <input v-model="dataSearch.name" type="text" class="form-control" id="name" name="name">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Localidade</label> <select v-model="dataSearch.locale">
                        <option value="">Selecione</option>
                        <option value="0">Brasil</option>
                        <option value="1">Portugal</option>
                        <option value="2">Espanha</option>
                        <option value="3">Estados Unidos</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo Pagamento</label> <select v-model="dataSearch.selectedPayment">
                        <option value="">Selecione</option>
                        <option value="0">Free/Trial</option>
                        <option value="1">CLIENTES free</option>
                        <option value="2">Até 10 funcionarios</option>
                        <option value="3">Acima 10 funcionarios</option>
                        <option value="5">Todos clientes Pagantes</option>
                        <option value="6">Todos</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo Status</label> <select v-model="dataSearch.selectedStatus">
                        <option value="">Selecione</option>
                        <option value="0">Todas</option>
                        <option value="1">Ativas</option>
                        <option value="2">Desativadas</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="input-group input-with-date">
                        <label>Data Inicial</label>
                        <datepicker ref="programaticOpen3" v-model="dataSearch.initialDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="input-group input-with-date">
                        <label>Data Final</label>
                        <datepicker ref="programaticOpen4" v-model="dataSearch.finalDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label for="cnpj">CNPJ</label>
                        <input v-model="dataSearch.cnpj" type="text" class="form-control" id="cnpj" name="cnpj"
                               v-mask="['##.###.###/####-##']">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label for="email">E-mail</label>
                        <input v-model="dataSearch.email" type="text" class="form-control" id="email" name="email">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label>Produtos</label> <select v-model="dataSearch.moduleType">
                        <option value="0">Ponto</option>
                        <option value="1">Benefícios</option>
                        <option value="2">Benefícios + Ponto</option>
                        <option value="3">Todos</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label>Jornada do cliente</label> <select v-model="dataSearch.clientJourney">
                        <option value="">Todos</option>
                        <option value="0">Lead</option>
                        <option value="1">Onboarding</option>
                        <option value="2">Middle</option>
                        <option value="3">Ongoing</option>
                        <option value="4">Resale</option>
                      </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label>MarQboard bloqueada</label>
                        <select v-model="dataSearch.isBlockedMarqboard">
                          <option :value="null">Todas</option>
                          <option :value="true">Apenas bloqueadas</option>
                          <option :value="false">Apenas não bloqueadas</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group">
                        <label>Inadimplente</label>
                        <select v-model="dataSearch.inadimplente">
                          <option :value="null">Todas</option>
                          <option :value="true">Apenas inadimplentes</option>
                          <option :value="false">Apenas adimplentes</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 offset-top-10">
                      <div class="form-group total-employee">
                        <label>Quantidade de colaboradores</label>
                        <div class="input-qtd">
                          <span>De:</span>
                          <input v-model="dataSearch.qtdMin" type="text" class="form-control" id="qtdMin" name="qtdMin"
                                 v-mask="'######'">
                          <span>Até</span>
                          <input v-model="dataSearch.qtdMax" type="text" class="form-control" id="qtdMax" name="qtdMax"
                                 v-mask="'######'">
                        </div>
                      </div>
                    </div>

                    <!-- M6 - Filtro por tags -->
                    <div class="col-xs-12 col-sm-12 col-md-6 offset-top-10">
                      <div class="form-group">
                        <label>Filtrar por tags</label>
                        <div class="tags-filter">
                          <label v-for="t in allTags" :key="t.id" class="tag-checkbox"
                                 :style="{ borderColor: t.color }">
                            <input type="checkbox" :value="t.id" v-model="dataSearch.selectedTags"/>
                            <span class="tag-pill" :style="{ backgroundColor: t.color }">{{ t.name }}</span>
                          </label>
                          <span v-if="!allTags.length" class="empty-tags">Nenhuma tag cadastrada.</span>
                        </div>
                      </div>
                    </div>

                    <!-- M8 - Filtro por features ativas -->
                    <div class="col-xs-12 col-sm-12 col-md-6 offset-top-10">
                      <div class="form-group">
                        <label>Filtrar por funcionalidades ativas</label>

                        <div class="features-match-mode">
                          <label class="match-option" title="Empresa precisa ter TODAS as funcionalidades selecionadas ativas.">
                            <input type="radio" :value="true" v-model="dataSearch.featureMatchAll"/>
                            <span>Todas (AND)</span>
                          </label>
                          <label class="match-option" title="Basta ter pelo menos uma das funcionalidades ativas.">
                            <input type="radio" :value="false" v-model="dataSearch.featureMatchAll"/>
                            <span>Pelo menos uma (OR)</span>
                          </label>
                        </div>

                        <div class="features-filter" :class="{ open: featuresOpen }">
                          <div class="features-summary" @click="featuresOpen = !featuresOpen">
                            <span v-if="dataSearch.selectedFeatures.length === 0">Nenhuma selecionada</span>
                            <span v-else>{{ dataSearch.selectedFeatures.length }} selecionada(s) — {{ dataSearch.featureMatchAll ? 'AND' : 'OR' }}</span>
                            <ion-icon name="chevron-down-outline"/>
                          </div>
                          <div v-if="featuresOpen" class="features-dropdown">
                            <input v-model="featureSearch" placeholder="Buscar..." class="features-search"/>
                            <div class="features-list">
                              <!-- Filtra por f.featureType (enum) - estável entre shards. -->
                              <label v-for="f in filteredFeatures" :key="f.featureType" class="feature-row">
                                <input type="checkbox" :value="f.featureType" v-model="dataSearch.selectedFeatures"/>
                                <span>{{ f.name }}</span>
                              </label>
                              <span v-if="!filteredFeatures.length" class="empty-tags">Nenhuma feature encontrada.</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 offset-top-10">
                    <button type="submit">Pesquisar</button>
                  </div>
                </form>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataCompany !== '' && !dataCompany.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- FB9c - modal de edição em massa -->
            <modal-bulk-update-company-flags :company-ids="selectedCompanyIds" @done="onBulkDone"/>

            <!-- Tags em massa (add/remover, sem senha, limite 200) -->
            <modal-bulk-company-tags :company-ids="selectedCompanyIds" :tags="allTags" @done="onBulkTagsDone"/>

            <!-- Table -->
            <div v-if="!loadingList && dataCompany.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                  <span class="caption-subject font-blue bold uppercase">
                    Quantidade total de empresas
                    ({{ dataCompany.length }})
                  </span>
                  </div>

                  <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span> <i class="fa fa-file-excel-o" aria-hidden="true"></i> </a>

                  <!-- FB9c - botão de edição em massa (aparece quando 1+ empresas marcadas) -->
                  <a v-if="selectedCompanyIds.length > 0"
                     v-on:click="openBulkEdit()"
                     class="btn-bulk-edit right"
                     title="Edição em massa">
                    <span>Editar {{ selectedCompanyIds.length }} em massa</span>
                  </a>

                  <!-- Tags em massa (aparece quando 1+ empresas marcadas) -->
                  <a v-if="selectedCompanyIds.length > 0"
                     v-on:click="openBulkTags()"
                     class="btn-bulk-tags right"
                     title="Adicionar ou remover tags em massa">
                    <span>Tags em massa</span>
                  </a>

                  <!-- Exibir tags: carrega em lote as tags das empresas listadas -->
                  <label class="show-tags-toggle right" title="Exibir as tags de cada empresa na lista">
                    <input type="checkbox" v-model="showTags" @change="onToggleShowTags"/>
                    <span>Exibir tags</span>
                  </label>

                  <div class="orderBy">
                    <label> Ordem por: <select v-model="orderByValue">
                      <option value="name">Nome</option>
                      <option value="createdAt">Data de Criação</option>
                      <option value="expiratedAt">Data de Expiração</option>
                      <option value="totalEmployee">Qtd Fun.</option>
                    </select> </label>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-light table-icon">
                      <thead>
                      <tr>
                        <th>
                          <input type="checkbox" :checked="allChecked"
                                 @change="toggleAllChecked($event.target.checked)"
                                 title="Selecionar todas"/>
                        </th>
                        <th> NOME</th>
                        <th> EMAIL</th>
                        <th> TELEFONE</th>
                        <th> QTD DE FUN.</th>
                        <th> JORNADA</th>
                        <th> SOLUÇÕES</th>
                        <th> ATIVO</th>
                        <th> CADASTRADO</th>
                        <th> EXPIRA</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(c, index) in orderBy(dataCompany, orderByValue)" :key="index">
                        <td>
                          <input type="checkbox" :value="c.id" v-model="selectedCompanyIds"/>
                        </td>
                        <td>
                          <a :href="'/detalhes-da-empresa/' + c.id + '/' + c.contextCode"
                             target="_blank">{{ c.name }}</a>
                          <div v-if="showTags" class="row-tags">
                            <span v-for="t in (tagsByCompany[c.id] || [])" :key="t.id"
                                  class="tag-pill" :style="{ backgroundColor: t.color }"
                                  :title="t.description">{{ t.name }}</span>
                            <span v-if="!loadingRowTags && !(tagsByCompany[c.id] || []).length"
                                  class="row-tags-empty">—</span>
                          </div>
                        </td>
                        <td>{{ c.email }}</td>
                        <td>{{ c.phone }}</td>
                        <td>{{ c.totalEmployee }}</td>
                        <td>
                           <span class="tag-benefits-list" style="background-color: #FF5531;"
                                 v-if="c.clientJourney === 0">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #BB3AD0;"
                                v-if="c.clientJourney === 1">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #FF9999 ;"
                                v-if="c.clientJourney === 2">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #52C977;"
                                v-if="c.clientJourney === 3">
                            {{ c.clientJourneyStr }}
                          </span>
                          <span class="tag-benefits-list"
                                style="background: linear-gradient(114.27deg, #7E43AA 5.39%, #421F5B 98.22%);"
                                v-if="c.clientJourney === 4">
                            {{ c.clientJourneyStr }}
                          </span>
                        </td>
                        <td>
                          <span class="tag-benefits-list" style="background-color: #3598DC;" v-if="c.moduleType === 0">
                            {{ c.moduleTypeStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #265389 ;" v-if="c.moduleType === 1">
                            {{ c.moduleTypeStr }}
                          </span>
                          <span class="tag-benefits-list" style="background-color: #4EB934;" v-if="c.moduleType === 2">
                            {{ c.moduleTypeStr }}
                          </span>
                        </td>
                        <td>
                          <span v-if="c.isActive === 'Ativo'" class="active">{{ c.isActive }}</span>
                          <span v-else class="disabled">{{ c.isActive }}</span>
                        </td>
                        <td>{{ c.createdAt | formatFullDate }}</td>
                        <td>{{ c.expiratedAt | formatDate }}</td>
                        <td class="no-wrap">
                          <a @click="goToFunil(c)" title="Visualizar" class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar </a>
                          <a v-if="c.isActive === 'Desativada'"
                             v-bind:href="'http://marqponto.com.br/cancelamento#' + c.contextCode + '&' + c.id"
                             title="Link de cancelamento para o cliente" class="btn-to-view" target="_blank">
                            <i class="fa fa-eye" aria-hidden="true"></i> Link de cancelamento </a>
                          <a v-if="c.isActive === 'Desativada' || c.plan === 'Cliente em Teste'"
                             v-on:click="activeModal(c);" title="Ativar/Desativar" class="btn-to-delete">

                            <i v-if="c.isActive === 'Desativada'" class="fa fa-check" aria-hidden="true">
                              <span> Ativar</span> </i> <i v-else class="fa fa-ban" aria-hidden="true">
                            <span> Desativar</span> </i> </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!--modal validation password-->
                    <div class="modal fade" id="password-modal" role="dialog">
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal">
                              &times;
                            </button>
                            <h4 class="title-modal">Confirmação de Permissão</h4>
                          </div>
                          <div class="modal-body text-center">
                            <div class="form-group">
                              <h4 class="text-danger">
                                <b>NÂO USAR ESSE BOTÂO PARA DAR CHURN</b>
                              </h4>
                            </div>
                            <div class="form-group">
                              <h4>Digite a senha para ter acesso</h4>
                            </div>
                            <input type="password" id="input-password" class="form-control" onfocus="this.value=''"
                                   v-model="modalPassword" autocomplete="off" placeholder="Password">
                            <button class="btn btn-register" @click="modalConfirmation(companySelected)"
                                    data-dismiss="modal" data-backdrop="false">Confirmar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import swal from 'sweetalert';
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import modalBulkUpdateCompanyFlags from "../../modals/modalBulkUpdateCompanyFlags.vue";
import modalBulkCompanyTags from "../../modals/modalBulkCompanyTags.vue";

import {
  ALL_COMPANY,
  DESACTIVE_ACTIVE,
  COMPANY_CHANCE_DADE_INFO,
  ENABLE_BENEFITS, GET_DATA_TO_FUNIL,
  COMPANY_TAGS,
  COMPANY_TAGS_BY_COMPANIES,
  FEATURES_AVAILABLE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import {target} from "vuelidate/lib/params";

export default {
  name: "all-company",
  components: {
    topMenu,
    datepicker,
    pageHeader,
    fullLoading,
    modalBulkUpdateCompanyFlags,
    modalBulkCompanyTags
  },
  data() {
    return {
      companySelected: "",
      modalPassword: "",
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      orderByValue: "name",
      orderByValuePlan: "2",
      dataCompany: '',
      dataCompanyUsers: '',
      dataSearch: {
        id: '',
        name: '',
        locale: null,
        initialDate: '',
        finalDate: '',
        selectedPayment: '',
        selectedStatus: 1,
        cnpj: '',
        email: '',
        moduleType: '3',
        clientJourney: '',
        qtdMin: '',
        qtdMax: '',
        // FB9a
        isBlockedMarqboard: null,
        inadimplente: null,
        // M6
        selectedTags: [],
        // M8
        selectedFeatures: [],
        featureMatchAll: true,
      },
      allTags: [],
      allFeatures: [],
      featureSearch: "",
      featuresOpen: false,
      // FB9c - edição em massa
      selectedCompanyIds: [],
      listOrder: [],
      // Exibir tags na listagem (carregamento em lote)
      showTags: false,
      tagsByCompany: {},
      loadingRowTags: false
    }
  },

  computed: {
    allChecked() {
      return this.dataCompany && this.dataCompany.length > 0
        && this.selectedCompanyIds.length === this.dataCompany.length;
    },
    filteredFeatures() {
      const q = (this.featureSearch || "").trim().toLowerCase();
      if (!q) return this.allFeatures;
      return this.allFeatures.filter((f) => (f.name || "").toLowerCase().includes(q));
    }
  },

  methods: {
    goToFunil(c) {
      let url = GET_DATA_TO_FUNIL + c.id;
      REQUEST_SERVICE.requestContext("GET", url, c.contextCode)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_DATA_TO_FUNIL:", response.data);

          window.open(
            "/empresa-detalhes-funil/" +
            response.data.pipelineId +
            "/" +
            response.data.id,
            "_blank"
          );
        })
        .catch(() => {
          window.open(
            "/detalhes-da-empresa/" + c.id + "/" + c.contextCode,
            "_blank"
          )
        });
    },
    refreshUser() {
      const typeCategory = this.$route.params.type;

      switch (typeCategory) {
        case '2':
          this.dataSearch.name = this.$route.params.value;
          break;
        case '3':
          this.dataSearch.cnpj = this.$route.params.value;
          break;
      }
    },
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    downloadActualListExcel() {
      let bodyValue = [];
      this.listOrder.map((value, index) => {
        bodyValue.push([value.id, value.name, value.phone, value.email, value.totalEmployee, value.plan, value.cnpj, value.contextCode, value.isActive, moment(String(value.createdAt)).format('DD/MM/YYYY'), moment(String(value.expiratedAt)).format('DD/MM/YYYY')]);

        if (index + 1 === this.listOrder.length) {
          let headValue = ["ID", "EMPRESA", "TELEFONE", "EMAIL", "QTD FUNCIONÁRIOS", "PLANO", "CNPJ", "BANCO", "ATIVO?", "DATA INÍCIO", "DATA EXPIRAÇÃO"];

          window.downloadListExcel(headValue, bodyValue, "Lista de empresas");
        }
      });
    },
    getList() {
      this.loadingList = true;
      let url = ALL_COMPANY + "?t=kkkk";
      const objSend = {
        t: 'kkkk'
      };

      if (this.dataSearch.selectedPayment)
        objSend.payment = this.dataSearch.selectedPayment;
      else
        objSend.payment = "6";
      if (this.dataSearch.selectedStatus)
        objSend.type = this.dataSearch.selectedStatus;
      else
        objSend.type = "0";
      if (this.dataSearch.name)
        objSend.name = this.dataSearch.name;
      if (this.dataSearch.id)
        objSend.id = this.dataSearch.id;
      if (this.dataSearch.cnpj)
        objSend.cnpj = this.dataSearch.cnpj;
      if (this.dataSearch.email)
        objSend.email = this.dataSearch.email;
      if (this.dataSearch.moduleType)
        objSend.moduleType = this.dataSearch.moduleType;
      if (this.dataSearch.clientJourney)
        objSend.clientJourney = this.dataSearch.clientJourney;
      if (this.dataSearch.initialDate)
        objSend.init = moment(this.dataSearch.initialDate).format("YYYY-MM-DD");
      if (this.dataSearch.finalDate)
        objSend.end = moment(this.dataSearch.finalDate).format("YYYY-MM-DD");
      if (this.dataSearch.locale)
        objSend.locale = Number(this.dataSearch.locale);

      if (this.dataSearch.qtdMin && this.dataSearch.qtdMax) {
        objSend.minEmployee = this.dataSearch.qtdMin;
        objSend.maxEmployee = this.dataSearch.qtdMax;
      }

      if (this.dataSearch.qtdMin && !this.dataSearch.qtdMax) {
        objSend.minEmployee = this.dataSearch.qtdMin;
        objSend.maxEmployee = '999999';
      }

      if (!this.dataSearch.qtdMin && this.dataSearch.qtdMax) {
        objSend.minEmployee = '1';
        objSend.maxEmployee = this.dataSearch.qtdMax;
      }

      // FB9a - MarQboard bloqueada e Inadimplente (Company.Default).
      if (this.dataSearch.isBlockedMarqboard !== null && this.dataSearch.isBlockedMarqboard !== undefined && this.dataSearch.isBlockedMarqboard !== "")
        objSend.isBlockedMarqboard = this.dataSearch.isBlockedMarqboard === true || this.dataSearch.isBlockedMarqboard === "true";
      if (this.dataSearch.inadimplente !== null && this.dataSearch.inadimplente !== undefined && this.dataSearch.inadimplente !== "")
        objSend.default = this.dataSearch.inadimplente === true || this.dataSearch.inadimplente === "true";

      // M6 - Filtro por tags (backend resolve via UNION dos shards).
      if (this.dataSearch.selectedTags && this.dataSearch.selectedTags.length)
        objSend.tagIds = this.dataSearch.selectedTags;

      // M8 - Filtro por features ativas (por FeatureType enum, AND/OR).
      if (this.dataSearch.selectedFeatures && this.dataSearch.selectedFeatures.length) {
        objSend.featureTypes = this.dataSearch.selectedFeatures;
        objSend.featureMatchAll = this.dataSearch.featureMatchAll !== false;
      }

      UTIL_SERVICE.console("URL SEARCH:", objSend);
      REQUEST_SERVICE.post(url, objSend).then((response) => {
        UTIL_SERVICE.console("RESULT ALL_COMPANY:", response.data);

        this.dataCompany = response.data;
        this.listOrder = response.data.slice().sort(function (a, b) {
          return a.totalEmployee - b.totalEmployee;
        }).reverse();
        this.loadingList = false;
        // Se "Exibir tags" estiver ligado, recarrega as tags do novo resultado.
        this.tagsByCompany = {};
        if (this.showTags) this.loadRowTags();
      }).catch((reason) => {
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    activeModal(company) {
      this.modalPassword = '';
      this.companySelected = company;
      $("#password-modal").modal();
    },
    activeOrDisableCompany(company) {
      if (company.isActive === 'Desativada' || company.plan === 'Cliente em Teste') {

        swal({
          title: "Aviso",
          text: "Você tem certeza que deseja executar essa ação na empresa:" + company.name + "\n\n\n Qual motivo?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
          content: {
            element: "div",
            attributes: {
              innerHTML: `
                <input type="text" id="reason" class="swal-content__input" placeholder="Qual motivo?">
                <div class="swal-box__inputs">
                    <input type="checkbox" id="reactivate">
                    <label for="reactivate" class="">Reativado como novo cliente?</label>
                </div>`,
            }
          },
        })
          .then((value) => {
            let checkbox = document.getElementById("reactivate");
            let inputText = document.getElementById("reason");
            if (value) {
              if (inputText.value) {
                this.loadingList = true;
                let url = DESACTIVE_ACTIVE + "?i=" + company.id + "&motive=" + inputText.value + "&reactivatedByNewClient=" + checkbox.checked;
                REQUEST_SERVICE.requestContext('GET', url, company.contextCode).then((response) => {
                  UTIL_SERVICE.console("RESULT DESACTIVE_ACTIVE:", response.data);
                  ALERT_SERVICE.swal("Aviso", response.data, "success");
                  this.getList();
                }).catch((reason) => {
                  this.loadingList = false;
                  swal('Aviso', reason.response.data.erros[0].value, 'error');
                });
              } else {
                swal('Aviso', 'Preencha o motivo para continuar!')
              }
            } else {
              swal('Aviso', 'Operação cancelada')
            }
          });
      } else {
        swal('Aviso', "")
      }
    },
    modalConfirmation(company) {
      UTIL_SERVICE.console("DATA COMPANY:", company);

      if (this.modalPassword === 'MMAARRQQchurn') {
        $("#password-modal").toggle("");
        this.activeOrDisableCompany(company)
        $("#modalChurn").modal();
        this.modalPassword = '';
      } else {
        $("#password-modal").toggle("");
        swal("Aviso", "Senha Errada!", "error");
        this.modalPassword = '';
      }
    },
    // FB9c - edição em massa
    toggleAllChecked(checked) {
      if (checked) {
        this.selectedCompanyIds = (this.dataCompany || []).map(c => c.id);
      } else {
        this.selectedCompanyIds = [];
      }
    },
    openBulkEdit() {
      if (!this.selectedCompanyIds.length) return;
      $("#modalBulkUpdateCompanyFlags").modal();
    },
    onBulkDone() {
      this.selectedCompanyIds = [];
      this.getList();
    },
    openBulkTags() {
      if (!this.selectedCompanyIds.length) return;
      // Garante o catálogo de tags carregado para o seletor do modal.
      if (!this.allTags.length) this.loadTags();
      $("#modalBulkCompanyTags").modal();
    },
    onBulkTagsDone() {
      // Mantém a seleção; recarrega as tags exibidas se "Exibir tags" estiver ligado.
      if (this.showTags) this.loadRowTags();
    },
    // M6 - catálogo de tags pro filtro multi-select
    loadTags() {
      REQUEST_SERVICE.get(COMPANY_TAGS)
        .then((r) => { this.allTags = r.data || []; })
        .catch(() => { this.allTags = []; });
    },
    // Exibir tags: ao marcar, busca em lote as tags das empresas listadas.
    onToggleShowTags() {
      if (this.showTags) this.loadRowTags();
    },
    // Carrega, em lotes, as tags de todas as empresas exibidas.
    // O banco de tags (Auth) não é shardeado, então cobre todos os shards.
    // Enviamos em lotes de 1000 ids porque o Dapper expande "IN @CompanyIds" em
    // um parâmetro por id e o SQL Server limita a 2100 parâmetros por comando —
    // uma busca ampla no master pode retornar milhares de empresas.
    loadRowTags() {
      const ids = (this.dataCompany || []).map(c => c.id).filter(Boolean);
      if (!ids.length) { this.tagsByCompany = {}; return; }

      const CHUNK = 1000;
      const batches = [];
      for (let i = 0; i < ids.length; i += CHUNK) {
        batches.push(ids.slice(i, i + CHUNK));
      }

      this.loadingRowTags = true;
      const requests = batches.map((batch) =>
        REQUEST_SERVICE.post(COMPANY_TAGS_BY_COMPANIES, { companyIds: batch })
      );

      Promise.all(requests)
        .then((responses) => {
          const map = {};
          responses.forEach((r) => {
            ((r && r.data) || []).forEach((t) => {
              const cid = t.companyId || t.CompanyId;
              if (!cid) return;
              if (!map[cid]) map[cid] = [];
              map[cid].push(t);
            });
          });
          this.tagsByCompany = map;
        })
        .catch(() => { this.tagsByCompany = {}; })
        .then(() => { this.loadingRowTags = false; });
    },
    // M8 - features pro filtro (deduplicado por featureType)
    loadFeatures() {
      REQUEST_SERVICE.get(FEATURES_AVAILABLE)
        .then((r) => {
          const seen = {};
          const list = (r.data || []).filter((f) => {
            if (f.isActive === false) return false;
            if (f.featureType === undefined || f.featureType === null) return false;
            if (seen[f.featureType]) return false;
            seen[f.featureType] = true;
            return true;
          });
          this.allFeatures = list.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
        })
        .catch(() => { this.allFeatures = []; });
    }
  },
  beforeMount() {
    this.refreshUser();
    this.loadTags();
    this.loadFeatures();
  }
}
</script>

<style lang="scss">

.btn-bulk-edit {
  display: inline-block; background: #c0392b; color: #fff !important;
  padding: 6px 14px; border-radius: 4px; font-weight: 600;
  cursor: pointer; margin-right: 10px; font-size: 13px;
}
.btn-bulk-edit:hover { background: #962d22; }

.btn-bulk-tags {
  display: inline-block; background: #3598dc; color: #fff !important;
  padding: 6px 14px; border-radius: 4px; font-weight: 600;
  cursor: pointer; margin-right: 10px; font-size: 13px;
}
.btn-bulk-tags:hover { background: #2a7bb3; }

.hint-help {
  display: inline-flex; align-items: center; justify-content: center;
  width: 16px; height: 16px; border-radius: 50%;
  background: #bbb; color: #fff; font-size: 10px; cursor: help;
  font-weight: bold; margin-left: 4px;
}

.features-match-mode {
  display: flex; gap: 12px; margin-bottom: 6px; font-size: 12px; color: #555;
  .match-option {
    display: inline-flex; align-items: center; gap: 4px; cursor: pointer; margin: 0;
    font-weight: normal;
    input { margin: 0 2px 0 0; }
  }
}

.features-filter {
  position: relative;
  border: 1px solid #ddd; border-radius: 4px; background: #fff; min-height: 38px;

  .features-summary {
    display: flex; justify-content: space-between; align-items: center;
    padding: 8px 10px; cursor: pointer; font-size: 13px;
  }
  .features-dropdown {
    position: absolute; top: 100%; left: 0; right: 0; z-index: 100;
    background: #fff; border: 1px solid #ddd; border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.08); margin-top: 4px;
    max-height: 320px; overflow: hidden; display: flex; flex-direction: column;
  }
  .features-search {
    border: none; border-bottom: 1px solid #eee; padding: 8px 10px; font-size: 13px;
    outline: none;
  }
  .features-list {
    overflow-y: auto; max-height: 260px; padding: 4px 0;
    .feature-row {
      display: flex; align-items: center; gap: 8px;
      padding: 6px 10px; margin: 0; font-size: 13px; cursor: pointer; font-weight: normal;
    }
    .feature-row:hover { background: #f5f7fa; }
  }
}

.tags-filter {
  display: flex; flex-wrap: wrap; gap: 6px; align-items: center;
  padding: 6px; border: 1px solid #ddd; border-radius: 4px; min-height: 38px;

  .tag-checkbox {
    display: inline-flex; align-items: center; gap: 4px;
    border: 2px solid transparent; border-radius: 12px; padding: 1px;
    cursor: pointer; margin: 0;

    input { margin: 0 2px; }
    .tag-pill {
      color: #fff; font-size: 11px; padding: 3px 10px; border-radius: 12px;
      font-weight: 600; letter-spacing: 0.3px;
    }
  }
  .empty-tags { color: #999; font-size: 12px; }
}

/* Exibir tags: toggle no cabeçalho da tabela */
.show-tags-toggle {
  display: inline-flex; align-items: center; gap: 5px;
  cursor: pointer; margin: 0 12px 0 0; font-weight: 600; user-select: none;
  input { margin: 0; }
}

/* Chips de tags exibidos por linha na coluna NOME */
.row-tags {
  display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px;
  .tag-pill {
    color: #fff; font-size: 10px; padding: 2px 8px; border-radius: 10px;
    font-weight: 600; letter-spacing: 0.3px; white-space: nowrap;
  }
  .row-tags-empty { color: #bbb; font-size: 11px; }
}

.swal-box__inputs {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 2px;
}

.total-employee {
  .input-qtd {
    display: flex;
    align-items: center;
    gap: 3%;
  }
}

.btn-all-excel {
  cursor: pointer;
  display: inline-block;
  padding: 6px 10px 5px;
  margin-left: 10px;
  background-color: #00A651;
  color: #FFF;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #FFF;
    background-color: #008D45;
  }
}

.tag-benefits-list {
  padding: 2px 8px !important;
  border-radius: 4px !important;
  display: flex;
  margin: 0;
  color: #FFFFFF !important;
  justify-content: center;
  width: 95%;

  &:hover {
    cursor: auto;
  }
}

.contate-table {
  .active {
    background: #00A651;
    color: #FFFFFF;
    display: block;
    width: 100%;
    text-align: center;
    border-radius: 4px !important;
    height: 24px;
    padding: 0 10px;
    line-height: 25px;
  }

  .disabled {
    background: #E8505B;
    color: #FFFFFF;
    display: block;
    width: 100%;
    text-align: center;
    border-radius: 4px !important;
    height: 24px;
    padding: 0 10px;
    line-height: 25px;
  }
}

.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}

#password-modal {
  .error-msg {
    font-size: 12px;
    color: #E74A4E;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .btn-register {
    border-radius: 4px !important;
    background-color: #3598DC;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
    margin-top: 10px;
  }

  .close-btn {
    border-radius: 4px !important;
    background-color: #8B8787;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/allCompany.vue